<template>
    <div class="login-page">
        <div class="centerer">
            <div class="login-card">
                <login-old-domain-warning
                    v-if="isFromOldDomain"
                    :company="form.company"
                    :email="form.email"
                />
                <div
                    v-else
                    class="img-side"
                    :style="{
                        'background-image': 'url(' + require('@/assets/img/login-panel-bg.jpg') + ')'
                    }"
                >
                    <img class="logo" src="@/assets/img/brand-logo-white.svg" alt="" />
                    <div
                        style="
                            color: #fff;
                            position: absolute;
                            bottom: 10px;
                            left: 15px;
                            font-size: 10pt;
                        "
                    >
                        {{ version }}
                    </div>
                </div>
                <div class="form-side">
                    <el-form :model="form" ref="form" :rules="rules" label-position="top" v-loading="isLoading">
                        <el-form-item label="公司 ID" prop="company" v-if="!isTypNewCompanyId && companyList != null">
                            <el-select v-model="companyId" placeholder="請選擇公司ID" @change="handleCompanyIdSelectChange" style="width: 100%">
                                <el-option v-for="comp in companyList" :key="comp" :label="comp" :value="comp">
                                    <span style="float: left">{{ comp }}</span>
                                    <span style="float: right; color: #8492a6; font-size: 13px">
                                        <el-button type="text" size="small" style="color: #aaa" @click.stop.prevent="removeLoggedInCompanyId(comp)">移除</el-button>
                                    </span>
                                </el-option>
                                <el-option key="0" label="輸入新公司ID" value="0"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="公司 ID" prop="company" v-if="isTypNewCompanyId || companyList == null">
                            <el-input
                                type="text"
                                name="company-id"
                                v-model.trim="companyId"
                                ref="companyInput"
                                class="company-id-input"
                                @keyup.enter.native="switchInputFocus('email')"
                                :maxlength="25"
                                auto-complete="off"
                            >
                                <el-button slot="append" icon="el-icon-close" @click="handleCloseTypCompanyIdBtnClick" v-if="companyList != null"></el-button>
                            </el-input>
                        </el-form-item>
                        <el-form-item label="帳號 (E-mail)" prop="email">
                            <el-input type="text" name="username" v-model.trim="form.email" ref="emailInput" @keyup.enter.native="switchInputFocus('password')" maxlength="100" />
                        </el-form-item>
                        <el-form-item label="密碼" prop="password">
                            <el-input type="password" name="password" v-model="form.password" ref="passwordInput" @keyup.enter.native="login" show-password />
                        </el-form-item>
                        <el-alert :title="errorMsg" type="error" v-if="errorMsg != ''" :closable="false"></el-alert>
                        <el-row align="top" style="margin-top: 40px">
                            <el-col :sm="24" align="">
                                <el-tooltip class="item" effect="dark" content="請以新網址登入" placement="top" :manual="!isFromOldDomain">
                                    <el-button id="login-page-submit-btn" type="primary" @click="handleSubmitBtnClick" :loading="isLoading" :disabled="isFromOldDomain">登入</el-button>
                                </el-tooltip>
                            </el-col>
                            <el-col :sm="24">
                                <div class="link-buttons" style="">
                                    <el-button type="text" @click="handleForgotBtnClick">忘記密碼 / 解鎖</el-button>
                                    <div class="divider"></div>
                                    <el-button type="text" @click="onAccBtnClick">會計專區</el-button>
                                </div>
                            </el-col>
                        </el-row>
                    </el-form>
                </div>
            </div>
            <div class="maintain-card">
                為提供更優質的服務，Sokuji 將於本週三 20:00 至 24:00 進行系統例行維護，此期間將暫停系統服務，造成您的不便，敬請見諒。如有任何疑問，可洽詢LINE客服
                <a href="https://line.me/R/ti/p/@056wdwcl" target="_blank">@056wdwcl</a> ，或致電 0955-667-509
            </div>
        </div>
    </div>
</template>
<script>
import LoginOldDomainWarning from './LoginOldDomainWarning.vue';

export default {
    name: 'LoginPage',
    components: { LoginOldDomainWarning },
    data() {
        return {
            isLoading: false,
            isTypNewCompanyId: false,
            errorMsg: '',
            submitBtnTouchStatus: '',
            companyList: null,
            form: {
                company: '',
                email: '',
                password: '',
            },

            // 表單驗證
            rules: {
                company: [{ required: true, message: '請輸入公司 ID', trigger: 'change' }],
                email: [{ required: true, message: '請輸入帳號', trigger: 'blur' }],
                password: [{ required: true, message: '請輸入密碼', trigger: 'blur' }],
            },
        };
    },
    computed: {
        companyId: {
            get() {
                return this.form.company;
            },
            set(val) {
                this.form.company = val.toUpperCase();
            },
        },
        isFromOldDomain() {
            return window.location.host.indexOf('ahoo.tw') !== -1;
        },
        version() {
            // eslint-disable-next-line max-len
            // eslint-disable-next-line global-require, import/no-unresolved, import/no-absolute-path
            const pjson = require('/package.json');
            return pjson.version;
        },
    },
    methods: {
        handleCompanyIdSelectChange(cid) {
            if (cid === '0') {
                this.isTypNewCompanyId = true;
                setTimeout(() => {
                    this.companyId = '';
                    this.$refs.companyInput.focus();
                }, 2);
            }
        },
        handleCloseTypCompanyIdBtnClick() {
            this.companyId = '';
            this.isTypNewCompanyId = false;
        },

        reloadCompanyList() {
            this.companyList = JSON.parse(localStorage.getItem('companys'));
        },

        switchInputFocus(target) {
            if (target === 'company') {
                this.$refs.companyInput.$el.querySelector('input').focus();
            } else if (target === 'email') {
                this.$refs.emailInput.$el.querySelector('input').focus();
            } else if (target === 'password') {
                this.$refs.passwordInput.$el.querySelector('input').focus();
            }
        },
        handleSubmitBtnClick() {
            this.errorMsg = '';
            this.$refs.form.validate((valid) => {
                if (valid) {
                    this.login();
                }
            });
        },

        handleForgotBtnClick() {
            this.$router.push({
                name: 'forgotPassword',
                query: {
                    email: this.form.email,
                    company: this.form.company,
                },
            });
        },

        onSubmitTouchStart() {
            this.submitBtnTouchStatus = 'touching';
        },

        onSubmitTouchEnd() {
            this.submitBtnTouchStatus = '';
        },
        login() {
            if (this.isFromOldDomain) {
                this.$message.warning('請至 app.sokuji.tw 登入');
                return;
            }

            const company = this.form.company.trim();
            const email = this.form.email.trim();
            const { password } = this.form;

            this.isLoading = true;

            this.$store
                .dispatch('account/login', { company, email, password })
                .then(() => {
                    this.loginStatus = 'success';

                    // 紀錄登入過的公司ID
                    this.saveLoggedInCompanyId(company);
                    setTimeout(() => {
                        if (this.$route.query.url) {
                            this.$router.push(this.$route.query.url);
                        } else {
                            this.$router.push(`/${company}/index`);
                        }
                    }, 1);
                })
                .catch((err) => {
                    if (err.response) {
                        if (typeof err.response.data === 'object') {
                            this.showErrorMsg(err.response.data.code);
                        } else {
                            this.showErrorMsg(err.response.data);
                        }
                    } else if (err.request) {
                        this.showErrorMsg('目前無法連線到主機，請稍後再試。');
                    } else {
                        this.showErrorMsg('發生未知的錯誤，請稍後再試。');
                    }
                })
                .finally(() => {
                    this.isLoading = false;
                });
        },
        showErrorMsg(src) {
            switch (src) {
            case 0:
                this.errorMsg = '公司不存在';
                break;
            case 1:
                this.errorMsg = '帳號或密碼錯誤1次';
                break;
            case 2:
                this.errorMsg = '帳號或密碼錯誤2次';
                break;
            case 3:
                this.errorMsg = '帳號或密碼錯誤3次';
                break;
            case 4:
                this.errorMsg = '帳號已鎖，請前往「忘記密碼/解鎖」';
                break;
            case 5:
                this.errorMsg = '帳號或密碼錯誤';
                break;
            case 6:
                this.errorMsg = '帳號已停用';
                break;
            case 7:
                this.errorMsg = '公司試用期已到';
                break;
            case 8:
                this.errorMsg = '公司合約日期已到，請完成續約手續';
                break;
            default:
                this.errorMsg = src;
            }
        },
        saveLoggedInCompanyId(cid) {
            const companys = JSON.parse(localStorage.getItem('companys'));
            if (Array.isArray(companys)) {
                if (companys.indexOf(cid) === -1) {
                    companys.unshift(cid);
                    localStorage.setItem('companys', JSON.stringify(companys));
                }
            } else {
                localStorage.setItem('companys', JSON.stringify([cid]));
            }
        },
        removeLoggedInCompanyId(cid) {
            let companys = JSON.parse(localStorage.getItem('companys'));
            const index = companys.indexOf(cid);
            if (index > -1) {
                companys.splice(index, 1);
                if (companys.length === 0) companys = null;
                localStorage.setItem('companys', JSON.stringify(companys));
                this.reloadCompanyList();
                this.companyId = '';
            }
        },
        IsJsonString(str) {
            try {
                JSON.parse(str);
            } catch (e) {
                return false;
            }
            return true;
        },
        onAccBtnClick() {
            let accUrl = 'https://acc.sokuji.tw';

            const companyId = this.form.company.trim();
            if (companyId) {
                accUrl = `${accUrl}/auth/${companyId}/login/`;

                const email = this.form.email.trim();
                if (email) {
                    accUrl = `${accUrl}?eml=${email}`;
                }
            }
            window.location = accUrl;
        },
    },
    mounted() {
        this.form.company = this.$route.query.company_id;

        if (!this.form.company) {
            this.form.company = this.$store.getters['account/company'].toUpperCase();
        }

        this.form.email = this.$route.query.email;
        if (!this.form.email) {
            this.form.email = this.$store.getters['account/email'];
        }

        if (this.$route.query && this.$route.query.url) {
            const urlCompany = this.$route.query.url.split('/')[1];
            if (urlCompany) {
                this.form.company = urlCompany.toUpperCase();
            }
        }

        this.reloadCompanyList();
    },
};
</script>
<style lang="scss">
@import "@/assets/scss/vars.scss";

.login-page {
    display: table;
    width: 100%;
    height: 100%;

    .centerer {
        display: table-cell;
        vertical-align: middle;
        padding: 15px;
    }

    .login-card {
        display: block;
        max-width: 900px;
        margin: 0 auto 10vh auto;
        background-color: #fff;
        border: 6px solid #fff;
        border-radius: 23px;
        overflow: hidden;
        box-shadow: 0px 20px 30px rgba(0, 0, 0, 0.1);

        @media (min-width: 992px) {
            display: table;
        }

        .img-side {
            position: relative;
            vertical-align: top;
            display: none;
            width: 330px;
            background-color: $main-color;
            border-top-left-radius: 18px;
            border-bottom-left-radius: 18px;
            background-repeat: no-repeat;
            background-size: cover;

            @media (min-width: 992px) {
                display: table-cell;
            }

            .logo {
                position: absolute;
                top: 10px;
                left: 10px;
                width: 130px;
            }
        }

        .form-side {
            vertical-align: top;
            display: table-cell;
            width: 500px;
            background-color: #fff;
            padding: 25px 25px;

            @media (min-width: 992px) {
                padding: 50px 70px;
            }

            .el-form-item__label {
                padding-bottom: 0;
                color: #888;

                &:before {
                    display: none;
                }
            }

            .el-input__inner {
                background-color: $main-color-fade;
                color: $main-color;
                border: 0;
                font-size: 12pt;
            }
        }

        #login-page-submit-btn {
            width: 100%;
            border-radius: 25px;
            font-weight: bold;

            @media (min-width: 992px) {
                min-width: 150px;
            }
        }

        .forgot-pass-btn {
            border-radius: 25px;
            border: 0;
            width: 100%;
            margin-top: 10px;

            @media (min-width: 992px) {
                width: auto;
                margin-top: 0;
            }
        }
    }

    .maintain-card {
        max-width: 670px;
        margin: 0 auto 10vh auto;
        font-size: 10pt;
        color: #888;

        a {
            color: #888;
        }
    }

    .link-buttons {
        display: flex;
        justify-content: center;
        align-items: center;
        margin-top: 20px;
        padding-right: 38px;

        >.el-button.el-button--text {
            color: #888;
            &:hover {
                color: $main-color;
            }
        }

        .divider {
            width: 1px;
            height: 20px;
            background-color: #ccc;
            margin: 0 20px;
        }
    }
}

#login-forgot-pass-msg {
    padding: 10px;

    .title {
        color: $main-color;
        font-size: 12pt;
        margin-bottom: 12px;
    }

    p {
        line-height: 160%;
    }
}
</style>
